import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import borderMixin from 'styles/utils/borderMixin';
import { useSymbolFromCurrency } from '../../utils/CurrencyUtil';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const Icon = ({ className, children }) => <i className={className}>{children}</i>;

const StyledCurrencyInputWrapper = styled.div`
  position: relative;
`;

const StyledCurrencyInput = styled.input`
  padding-left: 25px;
  padding-right: 0;
  padding-top: 3px;
  font-size: 14px;
  font-weight: 400;
  color: ${p4Tokens.colorNeutralForeground1};
  background-color: ${p4Tokens.colorNeutralBackground1};
  background-image: none;
  text-align: right;
  ${borderMixin} &:disabled {
    cursor: not-allowed;
  }
  width: 100%;
`;

const StyledCurrencyIcon = styled(Icon)`
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
  font-style: normal;
  color: darkgrey;
`;

const StyledDisabledCurrencyInput = styled.input`
  padding-top: 3px;
  font-size: 14px;
  font-weight: 400;
  color: ${p4Tokens.colorNeutralForeground1};
  background-color: ${p4Tokens.colorNeutralBackground1};
  background-image: none;
  text-align: right;
  ${borderMixin} &:disabled {
    cursor: not-allowed;
  }
  width: 100%;
`;

const CurrencyInput = forwardRef(
  (
    {
      id,
      decimals,
      disabled,
      testId,
      type,
      valueType,
      value,
      spellCheck,
      onChangeValue,
      onCommit,
      onCommitCancel,
      onOverrideKeyDown,
      onRowClick,
      ...rest
    },
    ref
  ) => {
    //Note: 'onWhatever' is included here to strip them from '...rest' that will be passed to the Styled Component.

    let ids = {};
    if (id) ids = { id, key: id, 'data-testid': testId };

    const currencySymbol = useSymbolFromCurrency(type, value);

    if (type === 'hide') {
      return <span>{'*'.repeat(value.length)}</span>;
    }

    let currencyValue = '';
    if (value) {
      currencyValue = `${currencySymbol}${currencySymbol.length > 1 ? ' ' : ''}${value}`;
    }

    if (disabled) {
      return (
        <StyledDisabledCurrencyInput
          ref={ref}
          disabled={true}
          autoComplete="off"
          type={type || 'text'}
          value={currencyValue}
          spellCheck={spellCheck}
          {...ids}
          {...rest}
        />
      );
    }

    return (
      <StyledCurrencyInputWrapper>
        <StyledCurrencyInput
          ref={ref}
          autoComplete="off"
          type={type || 'text'}
          value={value ?? ''}
          spellCheck={spellCheck}
          {...ids}
          {...rest}
        />
        <StyledCurrencyIcon>{currencySymbol}</StyledCurrencyIcon>
      </StyledCurrencyInputWrapper>
    );
  }
);

CurrencyInput.propTypes = {
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
CurrencyInput.defaultProps = {
  disabled: false,
  handleChange: () => {},
  id: '',
  testId: '',
  type: 'text',
};

export default CurrencyInput;
